const topo = document.querySelector('.topo');
const menu = document.querySelector('.topo__main');
const btn  = document.querySelector('.btn__toggle__menu');

// Classes que mostrarão/esconderão o menu
const showClass = 'topo__main--shown';
const hideClass = 'topo__main--hide';

// criando a div de fundo
const backdrop = document.createElement('div');

// Criando os métodos públicos para abrir/fechar o menu
const open = () => {
	btn.click();
}

const close = () => {
	backdrop.click();
}

// Modificando o backdrop
backdrop.classList.add('backdrop');

// Fechar o menu ao clicar no backdrop
backdrop.addEventListener('click', e => {
	e.preventDefault();

	menu.classList.add(hideClass);
	btn.setAttribute('aria-expanded', 'false');
	backdrop.classList.add('backdrop--hide');
});

// remover o backdro no termino do fadeOut
backdrop.addEventListener('animationend', () => {
	if(backdrop.classList.contains('backdrop--hide')) {
		topo.removeChild(backdrop);

		backdrop.classList.remove('backdrop--hide');
		menu.classList.remove(showClass, hideClass);
	}
});

// registrando o evento no botão de abrir o menu
btn.addEventListener('click', e => {
	e.preventDefault();

	btn.blur();
	menu.classList.add(showClass);
	topo.appendChild(backdrop);
});

// exportando os métodos
export default function useMobileControls () {
	return {
		open,
		close
	}
}
